import {
  Component,
  OnInit,
  Inject,
  forwardRef,
  ComponentFactoryResolver
} from '@angular/core';
import { DataEntityViewComponent } from '../../data-entity-view/data-entity-view.component';
import { DocumentDataEntityViewComponent } from '../../document-data-entity/document-data-entity-view/document-data-entity-view.component';
import {
  DocumentService,
  WorkflowContextService
} from '../../../../../services';
import { LayoutService } from 'src/app/services/layout.service';
// import { updateClassProp } from '@angular/core/src/render3/styling';

@Component({
    selector: 'wm-inspection-document-data-entity-view',
    templateUrl: './inspection-document-data-entity-view.component.html',
    styleUrls: ['./inspection-document-data-entity-view.component.css'],
    standalone: false
})
export class InspectionDocumentDataEntityViewComponent
  extends DocumentDataEntityViewComponent
  implements OnInit {
  constructor(
    public layoutService: LayoutService,
    componentFactoryResolver: ComponentFactoryResolver,
    @Inject(forwardRef(() => DocumentService)) uploadService: DocumentService,
    @Inject(forwardRef(() => WorkflowContextService))
    context: WorkflowContextService
  ) {
    super(layoutService, componentFactoryResolver, uploadService, context);
  }

  ngOnInit() {}
}
